import React from 'react'
import { Widget, mk_widget, Action, loadingAsyncState } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import { Link } from 'react-router-dom'
import { Page, TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { toRelativeUrl, decodeHTMLEntities } from '../../../helpers'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { Pagination } from './pagination.mod'
import { t } from 'i18next'

export const postOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  type: 'news' | 'case' | 'vacancy'
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  type: 'news' | 'case' | 'vacancy'
) =>
  mk_widget({
    run: (setState) => {
      const pageHeader = page.blocks.find((block) => block.kind == 'vidda/header')
      page.blocks.splice(page.blocks.indexOf(pageHeader))

      let posts =
        type == 'news' ? page.extra_data.news : type == 'case' ? page.extra_data.cases : page.extra_data.vacancies
      console.log('posts', posts)
      return (
        <>
          {posts.async.kind == 'loaded' ? (
            <>
              <section className="block block--grid block--grid-info block--light">
                <div className="block__inner grid--spacing">
                  <div className="block__content">
                    <ul className="block__grid grid">
                      {posts.async.value.kind == 'news'
                        ? posts.async.value.posts.map((post) => news_post(post))
                        : posts.async.value.kind == 'case'
                        ? posts.async.value.posts.map((post) => news_post(post))
                        : posts.async.value.posts.map((post) => news_post(post))}
                    </ul>
                  </div>
                </div>
              </section>

              <Pagination
                pager={{
                  current_page: posts.current_page,
                  items_per_page: 12,
                  total_items: posts.async.value.total_articles,
                  total_pages: posts.async.value.total_pages,
                }}
                setPage={(new_page: number) =>
                  setState((s) => {
                    return s.page.kind == 'loaded'
                      ? {
                          ...s,
                          page: {
                            ...s.page,
                            value: {
                              ...s.page.value,
                              extra_data:
                                type == 'news'
                                  ? {
                                      ...s.page.value.extra_data,
                                      news: {
                                        ...s.page.value.extra_data.news,
                                        async: get_posts(new_page, type),
                                        current_page: new_page,
                                      },
                                    }
                                  : {
                                      ...s.page.value.extra_data,
                                      stories: {
                                        ...s.page.value.extra_data.news,
                                        async: get_posts(new_page, type),
                                        current_page: new_page,
                                      },
                                    },
                            },
                          },
                        }
                      : s
                  })
                }
              />
            </>
          ) : (
            <section className="block block--grid block--grid-info">
              <div className="block__inner container--xl grid--block">
                <div className="loader">
                  <div className="loader__inner"></div>
                </div>
              </div>
            </section>
          )}
        </>
      )
    },
  })

function news_post(post: WordPress.NewsResponse | WordPress.CaseResponse | WordPress.VacancyResponse) {
  const dateToString = (date: Date) =>
    `${date.toLocaleString('nl', { day: 'numeric', month: 'long', year: 'numeric' })}`
  const header = post.custom_blocks.find((block) => block.blockName == 'vidda/header')
  return (
    <li className="grid__item">
      {post.link ? (
        <a className="grid__link" href={post.link}>
          <div className="grid__content">
            {post.type == "news" && <span className="grid__label typo--3xs">{dateToString(new Date(post.date))}</span>}
            <h2 className="grid__title typo--s">{decodeHTMLEntities(post.title.rendered)}</h2>
            {header && header.blockName == 'vidda/header' && (
              <p className="grid__intro typo--2xs" dangerouslySetInnerHTML={{ __html: header.attrs.intro }} />
            )}
            <span className="grid__fauxlink">{t('general.readMore')}</span>
          </div>
          <div className={`grid__visual fit-object${post.featured_media_object ? ' grid-has-image' : ''}`}>
            {post.featured_media_object && (
              <img
                src={post.featured_media_object.media_details.sizes.grid.source_url}
                width={post.featured_media_object.media_details.sizes.grid.width}
                height={post.featured_media_object.media_details.sizes.grid.height}
                alt={post.featured_media_object.alt_text}
              />
            )}
          </div>
        </a>
      ) : (
        <div className="grid__inner">
          <div className="grid__content">
            <span className="grid__label typo--3xs">{dateToString(new Date(post.date))}</span>
            <h2 className="grid__title typo--s">{decodeHTMLEntities(post.title.rendered)}</h2>
            {header && header.blockName == 'vidda/header' && (
              <p className="grid__intro typo--2xs" dangerouslySetInnerHTML={{ __html: header.attrs.intro }} />
            )}
          </div>
          <div className={`grid__visual fit-object${post.featured_media_object ? ' grid-has-image' : ''}`}>
            {post.featured_media && (
              <img
                src={post.featured_media_object.media_details.sizes.grid.source_url}
                width={post.featured_media_object.media_details.sizes.grid.width}
                height={post.featured_media_object.media_details.sizes.grid.height}
                alt={post.featured_media_object.alt_text}
              />
            )}
          </div>
        </div>
      )}
    </li>
  )
}

function story_post(post: WordPress.StoryResponse) {
  const header = post.custom_blocks.find((block) => block.blockName == 'vidda/header')
  return (
    <li className="grid__item">
      {post.link ? (
        <a className="grid__link" href={post.link}>
          <div className="grid__content">
            <h2 className="grid__title typo--s">{decodeHTMLEntities(post.title.rendered)}</h2>
            {header && header.blockName == 'vidda/header' && (
              <p className="grid__intro typo--2xs" dangerouslySetInnerHTML={{ __html: header.attrs.intro }} />
            )}
            <span className="grid__fauxlink">{t('general.readMore')}</span>
          </div>
          <div className={`grid__visual fit-object${post.featured_media_object ? ' grid-has-image' : ''}`}>
            {post.featured_media_object && (
              <img
                src={post.featured_media_object.media_details.sizes.grid.source_url}
                width={post.featured_media_object.media_details.sizes.grid.width}
                height={post.featured_media_object.media_details.sizes.grid.height}
                alt={post.featured_media_object.alt_text}
              />
            )}
          </div>
        </a>
      ) : (
        <div className="grid__inner">
          <div className="grid__content">
            <h2 className="grid__title typo--s">{decodeHTMLEntities(post.title.rendered)}</h2>
            {header && header.blockName == 'vidda/header' && (
              <p className="grid__intro typo--2xs" dangerouslySetInnerHTML={{ __html: header.attrs.intro }} />
            )}
          </div>
          <div className={`grid__visual fit-object${post.featured_media_object ? ' grid-has-image' : ''}`}>
            {post.featured_media_object && (
              <img
                src={post.featured_media_object.media_details.sizes.grid.source_url}
                width={post.featured_media_object.media_details.sizes.grid.width}
                height={post.featured_media_object.media_details.sizes.grid.height}
                alt={post.featured_media_object.alt_text}
              />
            )}
          </div>
        </div>
      )}
    </li>
  )
}

export function get_posts(page, postType: 'news' | 'case' | 'vacancy') {
  return loadingAsyncState<WordPress.OverviewResponse>((_) =>
    postType == 'news'
      ? WordPress.api<WordPress.NewsResponse>()
          .select(postType)
          .where({ per_page: 12, page: page + 1 })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: postType,
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
      : postType == 'case'
      ? WordPress.api<WordPress.CaseResponse>()
          .select(postType)
          .where({ per_page: 12, page: page + 1 })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: postType,
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
      : WordPress.api<WordPress.VacancyResponse>()
          .select(postType)
          .where({ per_page: 12, page: page + 1 })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: postType,
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
  )
}
